
import { mapGetters } from 'vuex'

export default {
  props: {
    item: { type: Object, required: true },
    field: { type: Object, required: true },
    value: { type: Boolean, default: false }
  },
  data () {
    return {
      fullValue: null
    }
  },
  computed: {
    ...mapGetters('dataset', ['resourceUrl']),
    itemValue () {
      return this.item[this.field.key]
    },
    detailValue () {
      return this.fullValue ?? this.itemValue
    }
  },
  watch: {
    value (val) {
      if (val) this.fetchFullValue()
    }
  },
  methods: {
    async fetchFullValue () {
      if (this.fullValue) return
      const data = await this.$axios.$get(this.resourceUrl + '/lines', {
        params: {
          qs: `_id:"${this.item._id}"`,
          select: this.field.key,
          html: true
        }
      })
      this.fullValue = data.results[0]?.[this.field.key]
    }
  }
}
